<app-header></app-header>
<!-- ======= Hero Section ======= -->
<section id="hero" class="d-flex flex-column justify-content-end align-items-center">
    <div id="heroCarousel" class="container carousel carousel-fade" data-ride="carousel">

        <!-- Titulo -->
        <div class="carousel-item active">
            <div class="carousel-container" style="height: 100%;">
                <h2 class="mt-4 animate__animated animate__faster animate__fadeInDown" style="margin-bottom: 0px;">
                    Eliminar una Quiniela
                </h2>
                <a routerLink="/quinielas" class="btn-get-started animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;width: 200px;">
                    <i class="icofont-arrow-left"></i> Volver
                </a>

                <section id="services" class="services" style="padding: 1rem;width: 100%;">
                    <div class="container">

                        <app-loader *ngIf="isLoading"></app-loader>

                        <div class="row" *ngIf="!isLoading">

                            <div class="col-lg-4 col-md-6 mb-5 mt-md-0 mt-lg-0" *ngFor="let quiniela of quinielas">
                                <div class="icon-box" data-aos="zoom-in-left">
                                    <div class="icon"><i class="icofont-football-alt" style="color: #33364a;"></i></div>
                                    <h4 class="title" style="margin-left: 0px;"><a href="">{{ quiniela.titulo }}</a>
                                    </h4>
                                    <p class="description" style="color: black;text-align: left;">
                                        <b>Evento: </b> {{ quiniela.copa }} <br />
                                        <b>Precio: </b> $ {{ quiniela.precio }} <br />
                                        <b>Teléfono: </b> <br />{{ quiniela.telefono }}<br />
                                        <b>Email: </b> <br />{{ quiniela.email }}
                                    </p>

                                    <a (click)="eliminar(quiniela)" class="btn-get-started-danger animate__animated animate__faster animate__fadeInDown" style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;">
                                        <i class="icofont-trash"></i> Eliminar
                                    </a>
                                </div>
                            </div>
                            <!--
                            <div class="col-lg-4 col-md-6 mb-5 mt-md-0 mt-lg-0">
                                <div class="icon-box" data-aos="zoom-in-left">
                                    <div class="icon"><i class="icofont-football-alt" style="color: #33364a;"></i></div>
                                    <h4 class="title" style="margin-left: 0px;"><a href="">Fundación Luz</a></h4>
                                    <p class="description" style="color: black;text-align: left;">
                                        <b>Evento: </b> Copa America <br />
                                        <b>Precio: </b> $ 5 <br />
                                        <b>Teléfono: </b> <br />+58 412 907 6968<br />
                                        <b>Email: </b> <br />manuel_marg@hotmail.com
                                    </p>
                                    <a href="#" data-toggle="modal" data-target="#crear"
                                        class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                                        style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;color: #fff;background-color: #6c757d;border-color: #6c757d;">
                                        <i class="icofont-edit"></i>
                                        Editar
                                    </a>
                                    <a href="#" data-toggle="modal" data-target="#crear"
                                        class="btn-get-started animate__animated animate__faster animate__fadeInDown"
                                        style="padding: .25rem .5rem;font-size: .875rem;line-height: 1.5;background-color:#ef6603;">
                                        <i class="icofont-swoosh-right"></i>
                                        Entrar
                                    </a>
                                </div>
                            </div>
                            -->

                        </div>

                    </div>
                </section>
                <!-- End Services Section -->


            </div>
        </div>
    </div>

    <svg class="hero-waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
        <defs>
            <path id="wave-path" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="wave1">
            <use xlink:href="#wave-path" x="50" y="3" fill="rgba(255,255,255, .1)" />
        </g>
        <g class="wave2">
            <use xlink:href="#wave-path" x="50" y="0" fill="rgba(255,255,255, .2)" />
        </g>
        <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
    </svg>


</section>
<!-- End Hero -->